import { Component, Inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { IconService } from 'src/app/shared/services/icon.service';
import { DOCUMENT } from '@angular/common';
import { FullscreenComponent } from 'src/app/shared/additional-styles/fullscreen-component';

@Component({
  selector: 'app-courses-card',
  templateUrl: './courses-card.component.html',
  styleUrls: ['./courses-card.component.scss', './courses-card.component.en.scss']
})
export class CoursesCardComponent extends FullscreenComponent implements OnInit, OnDestroy   {
  data: any;
  @Input({ required: true }) set pageData(value: any) {
    if (value) {
      if(value.icon) {
        this.iconService.addIconToRegistry({
          key: value.icon,
          path: value.icon,
        });
      } else {
        value.icon = 'courses';
      }  
      this.data = value;
    }
  }

  constructor(
    private iconService: IconService,
    renderer: Renderer2, 
    @Inject(DOCUMENT) document: Document
  ) {
    super(renderer, document);
  }

  ngOnInit() {
    super.setAddithonalStyles();
  }

  ngOnDestroy() {
    super.setAddithonalStyles(true);
  }
}
